import lang from '../stores/lang'
import getQualities from './getQualities'

const getTranslatedList = (keys, path) => (
  keys.length
    ? keys.map(value => lang.translate(`${path}.${value}`).toLowerCase()).join(', ')
    : '_____'
)

export default function getLifestyleSummaryValues(fields) {
  const motivations = fields.motivations || []
  const strengths = fields.strengths || []

  return {
    motivationValues: getTranslatedList(motivations, 'choices.motivation'),
    strengthValues: getTranslatedList(strengths, 'choices.strength'),
    qualityValues: getTranslatedList(getQualities(strengths), 'choices.quality'),
  }
}



// WEBPACK FOOTER //
// ./src/utils/getLifestyleSummaryValues.js